import { Box, Paper, Typography } from "@mui/material";

  const MapMessage = ({top, message}) => {
  
  return (
    <Box
      sx={{
        position: "absolute",
        top: top,
        right: "60px", 
        zIndex: 1000,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          px: 1.5,
          py: 0.5,
          borderRadius: "5px",
          bgcolor: "white",
          color: '#757575',
          display: "inline-block",
        }}
      >
        <Typography variant="body2">{message}</Typography>
      </Paper>
    </Box>
  );
}
export default MapMessage;
